


















































































































































































import {Component, Prop, Provide, Vue} from 'vue-property-decorator';
import SelectNodeField from '@c/controls/selectControls/SelectNodeField.vue';
import {PModuleTableHeader, PCrmModule} from '../interfaces';
import PModuleMeasurementEditDialog from '@v/system/modules/forms/PModuleMeasurementEditDialog.vue';
import Table from '@c/tables/Table.vue';
import TableCheckBox from '@c/tables/TableCheckBox.vue';
import SelectDialogField from '@c/controls/selectControls/SelectDialogField.vue';
import dtcpEnergyStoreModule from '@/store/modules/entities/pmodules/dtcp/dtcpEnergyStoreModule';
import {PModuleMeasurementStore} from './pModuleMeasurementStore';
import IconButton from '@c/controls/IconButton.vue';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import router from '@/router';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import enumsModule from '@/store/modules/enumsModule';
import {httpClient} from '@/api/baseApi';
import {PModuleType} from '@/enums/configs';
import {updateMeasurements} from '../moduleUtils';
import {EventDefaultValues} from '../../measurements/interfaces';
import PModuleButtons from './../../nodes/PModuleButtons.vue';
import nodeModule from '@/store/modules/entities/nodeModule';

@Component({
  components: {
    Table,
    TableCheckBox,
    SelectNodeField,
    PModuleMeasurementEditDialog,
    SelectDialogField,
    IconButton,
    CancelChangesDialog,
    PModuleButtons,
  },
})
export default class CrmModuleForm extends Vue {
  loading = false;
  saving = false;

  valid = true;

  nodeName: any = null;

  measurementDialog = PModuleMeasurementEditDialog;

  @Provide()
  @Prop({required: true})
  pmodule!: PCrmModule;

  moduleDefaultValues: EventDefaultValues[] = [];

  get measurementsStore() {
    return new PModuleMeasurementStore(this.pmodule);
  }

  measurementsHeaders: PModuleTableHeader[] = [
    {
      text: 'Измерение',
      value: 'measurementDescription',
      sortable: false,
    },
    {
      text: 'В. гр. предупреждения',
      value: 'topWarningBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. опасного значения',
      value: 'topDangerBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. ошибки',
      value: 'topErrorBoundary',
      sortable: false,
    },
  ];

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';

  nonNegativeNumberRule = (v: any) => v >= 0 || 'Поле должно быть неотрицательным числом';

  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  eventTypeNames: any = [];
  aliasTypeNames: any = [];

  onEventTypeChange() {
    this.pmodule.field_name = '';
    const aliasType = this.moduleDefaultValues.find(v => v.type === this.pmodule.event_name);
    this.aliasTypeNames = aliasType?.fields.map(v => ({
      description: v.description,
      type: v.alias,
    }));
  }

  async getDefaultValues() {
    const currentModuleType = enumsModule.moduleTypes.find(
      v => v.value === PModuleType.DtcpEnergyModule,
    );
    if (currentModuleType) {
      const moduleParametersResponse: {data: any} = await httpClient.get(
        `${currentModuleType.url}/events/event_types`,
      );

      this.moduleDefaultValues = moduleParametersResponse.data;
      if (!Array.isArray(this.moduleDefaultValues)) {
        console.log('issue with event types loading');
        return;
      }

      this.eventTypeNames = this.moduleDefaultValues.map(v => ({
        description: v.description,
        type: v.type,
      }));
      const aliasType = this.moduleDefaultValues.find(v => v.type === this.pmodule.event_name);
      this.aliasTypeNames = aliasType?.fields.map(v => ({
        description: v.description,
        type: v.alias,
      }));
    }
  }

  async onSave() {
    this.pmodule.measurements = this.pmodule.measurements.filter((x: any) => x.isActive === true);

    this.valid = await (this.$refs.form as any).validate();

    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && this.$vuetify.goTo(error as HTMLElement);
      return;
    }

    this.$emit('save');
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  // Действия при изменении поля
  async onChange() {
    this.changed = true;
  }

  async loadEnergyPMs() {
    await dtcpEnergyStoreModule.fetchAll();
    return [...dtcpEnergyStoreModule.all];
  }

  async loadMeasurements() {
    // Подгружаем список измерений, ещё не использованных в таблице
    await measurementsStoreModule.fetchAll();
    if (this.pmodule.measurements) {
      const newEntities = measurementsStoreModule.entities.filter(
        (x: any) =>
          x.moduleType === this.pmodule.type &&
          !this.pmodule.measurements.some((y: any) => y.measurementId == x.id),
      );
      // если такие измерения найдены, добавляем их в таблицу измерений модуля
      if (newEntities.length > 0) {
        updateMeasurements(this.pmodule.measurements, newEntities);
      }
    }
  }

  nodeFieldClick() {
    router.push(`/nodes/${this.pmodule.nodes ? this.pmodule.nodes[0].node_id : 0}`); //TODO: fix it?
  }

  async created() {
    if (this.pmodule.nodes && this.pmodule.nodes.length > 0) {
      const {data} = await nodeModule.edit(this.pmodule.nodes[0].node_id); //TODO: fix it?
      this.nodeName = data.name;
    }
    this.getDefaultValues();
    //для тех измерений, которые уже сохранены, проставляем isActive = true и isNew = false
    this.pmodule.measurements.forEach((elem: any) => {
      if (!elem.isNew) {
        (elem.isActive = true), (elem.isNew = false);
      }
    });

    await this.loadMeasurements();
  }

  get cancelChangesDialog() {
    return this.$refs.cancelChangesDialog as any;
  }

  back() {
    // если были внесены изменения на форме
    if (this.changed) {
      this.cancelChangesDialog.open('/modules');
    } else router.push('/modules');
  }
}
